import http from 'services/http-service';

const BankAccountService = {
    GetActiveBankAccounts() {
        let response = http.get('/bankaccounts');
        return response;
    }
};

export default BankAccountService;